
<template>
  <div class="wrapper" @click="handleClick">
    <div class="left-wrapper">
      <img class="image" :src="imgUrl? imgUrl : noPeriodPic" alt="" />
      <div class="period-name">{{periodName}}</div>
    </div>
    <div class="v-divide" ></div>
    <div class="right-wrapper">
      <div class="headers">
        <div :class="statusClass">{{getStatusText(status)}}{{'  ' + (hallName ? hallName : '')}}</div>
      </div>
      <div class="dishes" v-if="dishes && dishes.length >= 0">
        {{dishes.join('、')}}
      </div>
    </div>
  </div>
</template>

<script>
import noPeriodPic from '../assets/img/Periodname.png'
export default {
  props: {
    periodName: String,
    dishes: Array,
    status: String,
    imgUrl: String,
    index: Number,
    hallName: String
  },
  data () {
    return {
      noPeriodPic: noPeriodPic
    }
  },
  computed: {
    statusClass () {
      if (this.status === 'Ordered') return 'status-ordered'
      if (this.status === 'NotPayed') return 'status-not-payed'
      if (this.status === 'during') return 'status-during-order'
      return 'status-unorder'
    }
  },
  methods: {
    getStatusText (status) {
      if (status === 'Ordered') return '已点'
      if (status === 'NotPayed') return '未支付'
      if (status === 'during') return '继续点'
      return '未预定'
    },
    handleClick (e) {
      this.$emit('click', e)
    },
    imgColor (index) {
      let classes = ['#f9bdbb', '#e1bee7', '#a3e9a4', '#d0d9ff']
      return classes[index % 4]
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '../css/var'
$unpaid-color = #FEC172
$ordered-color = $primary-color
$during-ordering-color = #7AACFA
$dishes-text-color = #555555
$unorder-text-color = #888888

  .wrapper
    background-color white
    border-radius 10px
    padding pt(24)
    depth(1)
    // height pt(200)
    display flex
    align-items center
    .left-wrapper
      flex-basis pt(150)
      // height 100%
      display flex
      padding-right pt(30)
      flex-direction column
      justify-content center
      align-items flex-end
      .image
        width  pt(60)
        height pt(60)
      .period-name
        width  pt(60)
        // height pt(60)
        line-height pt(60)
        text-align center
        color $normal-text-color
    .v-divide
      vertical-divide(pt(40),pt(40))
      flex-basis 1px
    .right-wrapper
      width  "calc(100% - %s)" % pt(150)
      height 100%
      padding-left pt(30)
      display flex
      flex-direction column
      justify-content center
      align-items stretch
      .dishes
        color $dishes-text-color
        font-size $small-font-size
        single-line()
        margin-top pt(15)
      .status-ordered
        color $ordered-color
      .status-not-payed
        color $unpaid-color
      .status-during-order
        color $during-ordering-color
      .status-unorder
        color $unorder-text-color
      .headers
        display flex
        justify-content space-between
        text-align left

</style>



// WEBPACK FOOTER //
// period.vue?087e481c